import { Slot } from "@radix-ui/react-slot";
import type { VariantProps } from "class-variance-authority";
import spinnerIcon from "@/assets/shared/spinner.png";

import { buttonVariants } from "./buttonVariants";
import { cn } from "@/lib/utils";

interface ButtonProps
  extends React.ComponentProps<"button">,
    VariantProps<typeof buttonVariants> {
  asChild?: boolean;
  isLoading?: boolean;
  loadingText?: React.ReactNode;
}

const Spinner = () => <img src={spinnerIcon} className="animate-spin-slow" />;

const Button = ({
  className,
  variant,
  size,
  asChild = false,
  isLoading,
  loadingText,
  ...props
}: ButtonProps) => {
  const Comp = asChild ? Slot : "button";

  return (
    <Comp
      data-slot="button"
      className={cn(buttonVariants({ variant, size, className }))}
      disabled={props.disabled || isLoading}
      {...props}
    >
      {isLoading ? (
        <>
          <Spinner />
          {loadingText && <span>{loadingText}</span>}
        </>
      ) : (
        props.children
      )}
    </Comp>
  );
};

export { Button };
